import { Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    constructor(public commonService: CommonService) {}

    @HostBinding('class.dark') get isDarkMode() {
        return this.commonService.darkModeService.get();
    }

    @HostBinding('class.compact') get isCompactMode() {
        return this.commonService.compactModeService.get();
    }

    ngOnInit() {
        // Execute right after Angular’s initial setup but before any next macrotask
        queueMicrotask(async () => await this.commonService.userService.isJwtAuthenticated());
    }
}
